var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKitchen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#005EAD",
    d: "M14.3752 31.8318H.881104V.200022H14.3752V31.8318Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED1C27",
    d: "M29.095 31.8318H14.3756V21.1236H29.095v10.7082Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDE17",
    d: "M25.3165 7.30791V.200264h-7.2911V7.30791l-3.6502 3.07049H29.095l-3.7785-3.07049ZM29.095 21.1243H14.3756v-3.076H29.095v3.076ZM13.2696 19.6803c0 .38-.3082.6886-.6898.6886-.3792 0-.6882-.3086-.6882-.6886 0-.3804.309-.6887.6882-.6887.3816 0 .6898.3083.6898.6887Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#005EAD",
    d: "M18.3773 18.9916c-.3796 0-.6882.3083-.6882.6887 0 .3803.3086.6886.6882.6886.3804 0 .6886-.3083.6886-.6886 0-.3804-.3082-.6887-.6886-.6887ZM25.0927 18.9916c-.3804 0-.6886.3083-.6886.6887 0 .3803.3082.6886.6886.6886.3807 0 .689-.3083.689-.6886 0-.3804-.3083-.6887-.689-.6887ZM20.1246 20.3691h3.2214v-1.3772h-3.2214v1.3772Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitchen);
export default __webpack_public_path__ + "static/media/kitchen.836f1fcd0e05309faf8a348b1aaf3802.svg";
export { ForwardRef as ReactComponent };